export default function isCustomerTranslationEnabled() {
  const urlParams = new URLSearchParams(window.location.search);
  console.debug(urlParams.get("customerTranslationsEnabled"));
  return urlParams.get("customerTranslationsEnabled") === "true";
}
